export enum AddNumberFromAppRoutes {
  root = 'add-number-from-app',
  steps = 'steps',

  selectAppAndNumbers = 'select-app-and-numbers',
  assignNumber = 'assign-number',
}
